<h2>Feedback</h2>
<mat-card *ngFor="let item of feedback">
  <mat-card-content fxLayout.xs="column" fxLayout="row" fxLayoutGap="20px" fxLayoutGap.xs="10px">
    <div *ngIf="item.member" class="profile" fxFlex="0 0 20%" fxFlexAlign="top" fxLayout="column">
      <ca-avatar
        fxFlexAlign="center"
        [image]="item.member.profileImage | filedownloadurl"
        [fullName]="item.member | displayname"
      ></ca-avatar>
      <p class="member-name">
        <a [routerLink]="['team', item.member?.id]">
          <strong>{{ item.member | displayname }}</strong>
        </a>
      </p>
    </div>
    <div fxFlex>
      <ca-rating [rating]="item.rating" [showNumber]="false"></ca-rating>
      <mat-card-subtitle>{{ item.created | moment: 'fromNow' }}</mat-card-subtitle>
      <markdown [data]="item.message"></markdown>
    </div>
  </mat-card-content>
</mat-card>
